export default __webpack_public_path__ + "static/media/Default-pic.56d6b32a.png";